module.exports = __webpack_public_path__ + "static/media/ta.50e00043.png";